import { defineComponent as _defineComponent } from 'vue'
import { TrackCodeExecutionError } from '../hooks/useTrackCodeExecution'


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackCodeExecutionErrorRepresentation',
  props: {
    error: null,
    title: null
  },
  setup(__props: any) {

const props = __props as { error: TrackCodeExecutionError; title: string };



return { __sfc: true,props }
}

})